import { createRouter, createWebHistory } from 'vue-router'
import { lang, setLang } from '@/plugins/lang'


import MainPage from "@/pages/MainPage.vue";
import AboutUsPage from "@/pages/AboutWePage.vue";
import ContactPage from "@/pages/contactPage.vue";
import FAQPage from "@/pages/FAQPage.vue";
import ProductCategoryPage from "@/pages/ProductCategoryPage.vue";
import ProductPage from "@/pages/ProductPage.vue";
import CartPage from "@/pages/CartPage.vue";
import ShippingPage from "@/pages/ShippingPage.vue";
import DashboardPage from "@/pages/DashboardPage.vue";
import OrderPage from "@/pages/OrderPage.vue";
import OrderPrint from "@/pages/InvoicePrint.vue";
import AddressPage from "@/pages/AddressPage.vue";
import ProfilePage from "@/pages/ProfilePage.vue";



import auth from "@/middleware/auth.js";

const routes = [

  {
    path: '/',
    name: 'MainPageFa',
    component: MainPage,
    meta: { lang: 'fa', alternateName: 'MainPageFa' }
  },
  {
    path: '/en',
    name: 'MainPageEn',
    component: MainPage,
    meta: { lang: 'en', alternateName: 'MainPageEn' }
  },


  {
    path: '/درباره-ما',
    name: 'AboutUsPageFa',
    component: AboutUsPage,
    meta: { lang: 'fa', alternateName: 'AboutUsPageFa' }
  },
  {
    path: '/about-us',
    name: 'AboutUsPageEn',
    component: AboutUsPage,
    meta: { lang: 'en', alternateName: 'AboutUsPageEn' }
  },


  {
    path: '/تماس-با-ما',
    name: 'ContactPageFa',
    component: ContactPage,
    meta: { lang: 'fa', alternateName: 'ContactPageFa' }
  },
  {
    path: '/contact',
    name: 'AboutUsPageEn',
    component: ContactPage,
    meta: { lang: 'en', alternateName: 'ContactPageEn' }
  },


  {
    path: '/سوالات-متداول',
    name: 'FAQPageFa',
    component: FAQPage,
    meta: { lang: 'fa', alternateName: 'FAQPageFa' }
  },
  {
    path: '/FAQ',
    name: 'FAQPageEn',
    component: FAQPage,
    meta: { lang: 'en', alternateName: 'FAQPageEn' }
  },

  {
    path: '/product-category/:slug',
    name: 'ProductCategoryFa',
    component: ProductCategoryPage,
    props: true,
    meta: {
      lang: 'fa',
      alternateName: 'ProductCategoryFa'
    }
  },
  {
    path: '/en/product-category/:slug',
    name: 'ProductCategoryEn',
    component: ProductCategoryPage,
    props: true,
    meta: {
      lang: 'en',
      alternateName: 'ProductCategoryEn'
    }
  },

  {
    path: '/product/:slug',
    name: 'ProductFa',
    component: ProductPage,
    props: true,
    meta: {
      lang: 'fa',
      alternateName: 'ProductFa'
    }
  },
  {
    path: '/en/product/:slug',
    name: 'ProductEn',
    component: ProductPage,
    props: true,
    meta: {
      lang: 'en',
      alternateName: 'ProductEn'
    }
  },

  {
    path: '/fa/cart',
    // path: '/سبد-خرید',
    name: 'CartPageFa',
    component: CartPage,
    meta: { lang: 'fa', alternateName: 'CartPageFa' }
  },
  {
    path: '/cart',
    name: 'CartPageEn',
    component: CartPage,
    meta: { lang: 'en', alternateName: 'CartPageEn' }
  },


  {
    path: '/fa/cart/shipping',
    name: 'ShippingPageFa',
    component: ShippingPage,
    meta: { lang: 'fa', alternateName: 'ShippingPageFa' }
  },
  {
    path: '/en/cart/shipping',
    name: 'ShippingPageEn',
    component: ShippingPage,
    meta: { lang: 'en', alternateName: 'ShippingPageEn' }
  },




  // {
  //   path: '/fa/dashboard',
  //   name: 'DashboardPageFa',
  //   component: DashboardPage,
  //   meta: { lang: 'fa', alternateName: 'DashboardPageFa' }
  // },
  // {
  //   path: '/en/dashboard',
  //   name: 'DashboardPageEn',
  //   component: DashboardPage,
  //   meta: { lang: 'en', alternateName: 'DashboardPageEn' }
  // },




  {
    path: '/fa/dashboard',
    component: DashboardPage,
    redirect: '/fa/dashboard/orders',
    children: [
      {
        path: 'orders',
        name: 'ordersFa',
        component: OrderPage,
      },
      {
        path: 'orders/:id/print',
        name: 'ordersPrintFa',
        component: OrderPrint,
      },
      {
        path: 'address',
        name: 'addressFa',
        component: AddressPage,
      },

      {
        path: 'profile',
        name: 'profileFa',
        component: ProfilePage,
      }
      

    ],
    meta: { lang: 'fa', alternateName: 'DashboardPageFa' }
  },





  {
    path: '/en/dashboard',
    component: DashboardPage,
    redirect: '/en/dashboard/orders',
    children: [
      {
        path: 'orders',
        name: 'ordersEn',
        component: OrderPage,
      },
      {
        path: 'orders/:id/print',
        name: 'ordersPrintEn',
        component: OrderPrint,
      },
      {
        path: 'address',
        name: 'addressEn',
        component: AddressPage,
      },

      {
        path: 'profile',
        name: 'profileEn',
        component: ProfilePage,
      }
      

    ],
    meta: { lang: 'en', alternateName: 'DashboardPageEn'  ,requiresAuth: true, middleware: [auth]}
  },











  // {
  //   path: "/admin",
  //   name: "Admin",
  //   component: Admin,
  //   meta: {
  //     requiresAuth: true,
  //     middleware: [auth],
  //   },
  // },



];

const router = createRouter({
  history: createWebHistory(),
  routes
})


router.beforeEach((to, from, next) => {
  if (to.meta.lang && to.meta.lang !== lang.value) {
    setLang(to.meta.lang);
  }

  if (!to.meta.middleware) {
    return next();
  }

  const middlewares = Array.isArray(to.meta.middleware)
    ? to.meta.middleware
    : [to.meta.middleware];

  const context = { to, from, next, router };

  const runMiddlewares = (index) => {
    const middleware = middlewares[index];
    if (!middleware) return next();

    middleware({
      ...context,
      next: (...params) => {
        if (params.length > 0) {
          return next(...params);
        }
        runMiddlewares(index + 1);
      },
    });
  };

  runMiddlewares(0);
});

export default router